"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import RadioGroupControlled from "./RadioGroupControlled.js";
const RadioGroupUncontrolled = (props) => {
    const { defaultValue, onChange } = props;
    const [value, setValue] = React.useState(defaultValue || null);
    const handleChange = (args) => {
        if (!args.value)
            return;
        setValue(args.value);
        if (onChange)
            onChange(args);
    };
    return (_jsx(RadioGroupControlled, { ...props, value: value, defaultValue: undefined, onChange: handleChange }));
};
RadioGroupUncontrolled.displayName = "RadioGroupUncontrolled";
export default RadioGroupUncontrolled;
